import { all } from "redux-saga/effects";
import { watchMenuSaga } from "./sagas/menuSaga";
import { watchBankListSaga } from "./sagas/bankListSaga";
import { watchTestimonialSaga } from "./sagas/testimonialSaga";
import faqSaga from "./sagas/faqSaga";
import herosliderSaga from "./sagas/herosliderSaga";
import { watchFestival } from "./sagas/festivalSaga";
import { watchLoanProducts } from "./sagas/loanProductSaga";
import { watchSubServices } from "./sagas/subServiceSaga";
import { watchLoanDetails } from "./sagas/loanDetailsSaga";
import { watchSatisfiedCounter } from "./sagas/satisfiedCounterSaga";
import { watchToast } from "./sagas/toastSaga";
import { watchTeam } from "./sagas/teamSaga";
import { watchEnquiryFormSaga } from "./sagas/enquiryFormSaga";
import { watchDsaSaga } from "./sagas/dsaSaga";
import { watchLeadSaga } from "./sagas/leadSaga";
import { watchHelpServices } from "./sagas/helpServiceSaga";
import {
  watchInstantServiceDetail,
  watchInstantServiceActivity,
} from "./sagas/instantServiceSaga";
import { watchFetchServices } from "./sagas/instantServicesListSaga";
import { watchServices } from "./sagas/servicesSaga";

export default function* rootSaga() {
  yield all([
    watchMenuSaga(),
    watchBankListSaga(),
    watchTestimonialSaga(),
    faqSaga(),
    herosliderSaga(),
    watchFestival(),
    watchLoanProducts(),
    watchSubServices(),
    watchLoanDetails(),
    watchSatisfiedCounter(),
    watchToast(),
    watchTeam(),
    watchEnquiryFormSaga(),
    watchDsaSaga(),
    watchLeadSaga(),
    watchHelpServices(),
    watchInstantServiceDetail(),
    watchInstantServiceActivity(),
    watchFetchServices(),
    watchServices(),
  ]);
}
